var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServerDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 249,
    viewBox: "0 0 400 249",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2191_13141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.539 151.751C146.567 151.751 180.637 117.78 180.637 75.8755C180.637 33.9706 146.567 0 104.539 0C62.5116 0 28.4414 33.9706 28.4414 75.8755C28.4414 117.78 62.5116 151.751 104.539 151.751Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 18.2183C0 45.8248 17.3697 68.1637 38.8352 68.1637L0 18.2183Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8359 68.1633C38.8359 40.2466 58.2195 17.6567 82.1738 17.6567L38.8359 68.1633Z",
    fill: "#05E27E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0703 20.7207C14.0703 46.944 25.1466 68.1635 38.8348 68.1635L14.0703 20.7207Z",
    fill: "#05E27E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8359 68.1636C38.8359 32.4923 61.2403 3.62744 88.9278 3.62744L38.8359 68.1636Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6641 68.5156C30.6641 68.5156 36.1715 68.3465 37.8314 67.168C39.4912 65.9895 46.3032 64.5824 46.715 66.4724C47.1268 68.3624 54.9917 75.8725 48.7738 75.9225C42.5559 75.9725 34.3261 74.9568 32.6695 73.9506C31.0129 72.9445 30.6641 68.5156 30.6641 68.5156Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M48.8848 75.2644C42.6668 75.3144 34.4371 74.2987 32.7805 73.2925C31.5189 72.5263 31.0161 69.7768 30.8479 68.5083C30.7314 68.5133 30.6641 68.5154 30.6641 68.5154C30.6641 68.5154 31.0129 72.9443 32.6695 73.9504C34.3261 74.9566 42.5559 75.9723 48.7738 75.9223C50.5687 75.9079 51.1886 75.2711 51.1546 74.3281C50.9052 74.8979 50.2207 75.2537 48.8848 75.2644Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9575 160.279C107.855 160.279 137.766 156.222 137.766 151.217C137.766 146.212 107.855 142.154 70.9575 142.154C34.0599 142.154 4.14844 146.212 4.14844 151.217C4.14844 156.222 34.0599 160.279 70.9575 160.279Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M70.9582 158.825C101.936 158.825 127.049 155.419 127.049 151.217C127.049 147.015 101.936 143.608 70.9582 143.608C39.98 143.608 14.8672 147.015 14.8672 151.217C14.8672 155.419 39.98 158.825 70.9582 158.825Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.892 249C354.732 249 399.999 242.86 399.999 235.285C399.999 227.711 354.732 221.571 298.892 221.571C243.052 221.571 197.785 227.711 197.785 235.285C197.785 242.86 243.052 249 298.892 249Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.97 238.181C144.513 238.181 171.705 234.492 171.705 229.942C171.705 225.392 144.513 221.704 110.97 221.704C77.4266 221.704 50.2344 225.392 50.2344 229.942C50.2344 234.492 77.4266 238.181 110.97 238.181Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.273 222.996C197.428 231.189 259.235 212.309 266.023 190.936",
    stroke: "#2F2E41",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.613 92.2618C110.613 92.2618 157.058 79.4378 159.916 120.76C162.774 162.082 121.689 173.837 153.843 182.03",
    stroke: "#2F2E41",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7422 191.393C65.7422 191.393 79.7015 187.539 80.5605 199.958C81.4195 212.378 69.0709 215.911 78.735 218.373",
    stroke: "#2F2E41",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.204 200.639L275.39 218.555C275.39 218.555 261.534 225.894 271.276 226.11C281.018 226.326 326.915 226.11 326.915 226.11C326.915 226.11 335.791 226.11 321.719 218.339L318.904 199.56L278.204 200.639Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M269.317 225.916C271.53 223.953 275.391 221.908 275.391 221.908L278.205 203.991L318.905 204.029L321.72 221.692C325.001 223.504 327.034 224.893 328.223 225.959C330.031 225.547 332.006 224.02 321.72 218.339L318.905 199.56L278.205 200.639L275.391 218.555C275.391 218.555 263.748 224.723 269.317 225.916Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.578 75.7646H213.103C209.543 75.7646 206.656 78.6427 206.656 82.1929V196.693C206.656 200.243 209.543 203.122 213.103 203.122H383.578C387.138 203.122 390.025 200.243 390.025 196.693V82.1929C390.025 78.6427 387.138 75.7646 383.578 75.7646Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.853 82.564H212.824V177.974H383.853V82.564Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.34 80.6215C298.938 80.6215 299.423 80.1383 299.423 79.5422C299.423 78.9461 298.938 78.4629 298.34 78.4629C297.742 78.4629 297.258 78.9461 297.258 79.5422C297.258 80.1383 297.742 80.6215 298.34 80.6215Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.025 185.529V196.693C390.025 197.537 389.858 198.373 389.534 199.153C389.21 199.933 388.736 200.642 388.137 201.239C387.538 201.836 386.827 202.309 386.045 202.632C385.263 202.955 384.424 203.121 383.578 203.121H213.103C212.257 203.121 211.418 202.955 210.636 202.632C209.854 202.309 209.143 201.836 208.544 201.239C207.946 200.642 207.471 199.933 207.147 199.153C206.823 198.373 206.656 197.537 206.656 196.693V185.529H390.025Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.184 237.767V239.926H229.711V238.199L229.871 237.767L232.742 229.996H343.802L346.184 237.767Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.008 235.654C390.795 236.558 389.994 237.512 388.184 238.415C381.69 241.653 368.484 237.551 368.484 237.551C368.484 237.551 358.309 235.824 358.309 231.291C358.594 231.096 358.892 230.92 359.201 230.762C361.931 229.322 370.985 225.768 387.038 230.913C388.221 231.283 389.277 231.973 390.089 232.907C390.74 233.666 391.25 234.629 391.008 235.654Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M391.006 235.654C383.057 238.691 375.971 238.918 368.699 233.882C365.031 231.343 361.7 230.715 359.199 230.762C361.93 229.322 370.983 225.768 387.037 230.913C388.219 231.283 389.276 231.973 390.088 232.907C390.739 233.666 391.249 234.629 391.006 235.654Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.041 233.881C382.595 233.881 383.855 233.495 383.855 233.018C383.855 232.541 382.595 232.154 381.041 232.154C379.487 232.154 378.227 232.541 378.227 233.018C378.227 233.495 379.487 233.881 381.041 233.881Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.34 198.48C300.612 198.48 302.453 196.644 302.453 194.379C302.453 192.114 300.612 190.278 298.34 190.278C296.068 190.278 294.227 192.114 294.227 194.379C294.227 196.644 296.068 198.48 298.34 198.48Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M346.184 237.767V239.926H229.711V238.199L229.871 237.767H346.184Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.112 56.6396H38.8008V142.846H113.112V56.6396Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.618 48.0903H31.3008V78.7255H120.618V48.0903Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.618 84.4248H31.3008V115.06H120.618V84.4248Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.618 120.76H31.3008V151.395H120.618V120.76Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M102.755 53.4336H97.0391V59.1332H102.755V53.4336Z",
    fill: "#05E27E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M110.97 53.4336H105.254V59.1332H110.97V53.4336Z",
    fill: "#05E27E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.189 53.4336H113.473V59.1332H119.189V53.4336Z",
    fill: "#05E27E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M102.755 89.4121H97.0391V95.1117H102.755V89.4121Z",
    fill: "#05E27E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M110.97 89.4121H105.254V95.1117H110.97V89.4121Z",
    fill: "#05E27E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.189 89.4121H113.473V95.1117H119.189V89.4121Z",
    fill: "#05E27E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M102.755 125.391H97.0391V131.09H102.755V125.391Z",
    fill: "#05E27E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M110.97 125.391H105.254V131.09H110.97V125.391Z",
    fill: "#05E27E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.189 125.391H113.473V131.09H119.189V125.391Z",
    fill: "#05E27E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.115 219.79C128.703 219.79 141.339 207.19 141.339 191.648C141.339 176.106 128.703 163.506 113.115 163.506C97.527 163.506 84.8906 176.106 84.8906 191.648C84.8906 207.19 97.527 219.79 113.115 219.79Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.828 213.734H100.254V229.051H108.828V213.734Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.977 213.734H117.402V229.051H125.977V213.734Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.399 231.901C111.346 231.901 114.545 230.705 114.545 229.23C114.545 227.754 111.346 226.558 107.399 226.558C103.453 226.558 100.254 227.754 100.254 229.23C100.254 230.705 103.453 231.901 107.399 231.901Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.548 231.545C128.494 231.545 131.693 230.349 131.693 228.873C131.693 227.398 128.494 226.202 124.548 226.202C120.601 226.202 117.402 227.398 117.402 228.873C117.402 230.349 120.601 231.545 124.548 231.545Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.83 194.142C119.157 194.142 123.476 189.836 123.476 184.524C123.476 179.212 119.157 174.906 113.83 174.906C108.502 174.906 104.184 179.212 104.184 184.524C104.184 189.836 108.502 194.142 113.83 194.142Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.829 187.729C115.605 187.729 117.044 186.294 117.044 184.523C117.044 182.753 115.605 181.317 113.829 181.317C112.053 181.317 110.613 182.753 110.613 184.523C110.613 186.294 112.053 187.729 113.829 187.729Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7376 165.477C83.4586 155.301 90.7435 145.018 102.009 142.51C113.274 140.002 124.254 146.218 126.533 156.395C128.812 166.571 121.346 170.324 110.081 172.832C98.8154 175.341 88.0165 175.654 85.7376 165.477Z",
    fill: "#05E27E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.585 186.035C146.75 182.978 151.778 178.681 150.816 176.438C149.853 174.195 143.264 174.856 136.099 177.914C128.934 180.971 123.905 185.268 124.868 187.511C125.831 189.754 132.42 189.093 139.585 186.035Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7101 204.915C93.8753 201.857 98.9033 197.56 97.9406 195.317C96.9779 193.075 90.3889 193.735 83.2237 196.793C76.0585 199.851 71.0305 204.148 71.9932 206.391C72.9559 208.633 79.5449 207.973 86.7101 204.915Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.547 199.841C129.547 202.595 122.435 208.034 114.542 208.034C106.65 208.034 99.1797 202.952 99.1797 200.197C99.1797 197.443 106.65 198.06 114.542 198.06C122.435 198.06 129.547 197.087 129.547 199.841Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2191_13141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 249,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerDown);
export default __webpack_public_path__ + "static/media/ServerDown.c83781c2a489fa1bff1f1729db4a218e.svg";
export { ForwardRef as ReactComponent };